<!--
 * @Author: qx
 * @Date: 2022-10-18 17:02:56
 * @LastEditTime: 2022-10-25 14:56:20
 * @LastEditors: qx
 * @Description: 用户协议
-->
<template>
  <div>
    <el-dialog :title="$t('login.privacyPolicy')"
               :close-on-click-modal="false"
               :visible.sync="visible"
               :before-close="closeHandle"
               append-to-body
               v-if="visible">
      <div class="site-wrapper site-page__not-found site-wrapper--full" style="height: 500px;width: 100%;overflow: auto;">
        <div class="content">
          <h2 style="margin: 50px auto 10px;text-align:center; font-size:1.5em;">{{info.agreementTitle}}</h2>
          <div class="ql-editor" v-html="info.agreementContent || ''"></div>
        </div>
      </div>
      <!-- <iframe src="https://www.plantmate.com/PlantmateUserAgr/"
              width="100%"
              height="500"
              frameborder="0"
              scrolling="auto"
              id="iframename"
              name="iframename"></iframe> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data () {
    return {
      agreementType: '10',
      info: {}
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.$http.get(`/front/integratedManagement/web-agreement/getAgreementInfo/${this.agreementType}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.info = res.data || []
          }
        })
    },
    closeHandle () {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.forget-pw-title {
  font-size: 12px;
  margin-top: -20px;
  margin-bottom: 20px;
}
.font-weight{
  font-weight: bold;
}
.undeline{
  text-decoration: underline;
}
.content{
  text-align:left;
  color:#333;
  font-size: 16px;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",Arial,sans-serif;
  /* line-height: 1.5; */
  margin: 10px 3%;
}
.ql-align-center{
  /* text-align: center; */
}
/deep/ p {
  text-indent: 2em;
  color: #333;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
